import Encour from './views/Encour.vue'

const route = [
  {
    path: '/mes-encours',
    name: 'encour',
    component: Encour,
    meta: {
      layout: 'default',
      auth: true,
      menu: true,
      title: 'Mes encours',
      lang_code: 'my_outstandings',
      role: ['A','R','C','I'],
      customer_required: true,
      order: 9
    }
  }
]

export default route